import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { IntelliProveWidgets } from 'intelliprove-widget-sdk';

interface iIntelliProveAPIContext {
  children: React.ReactNode;
  actionToken: string;
  locale: string | null;
  apiurl?: string;
}

// Create a context for the IntelliProveAPI instance, defaulting to null.
const IntelliProveWidgetsContext = createContext<IntelliProveWidgets | null>(null);

export function IntelliProveWidgetsProvider({ children, actionToken, locale, apiurl }: iIntelliProveAPIContext) {
  const lang = locale?.toLowerCase();
  const intelliProveWidgets = useMemo(() => {
    const sdk = new IntelliProveWidgets(actionToken, apiurl ?? undefined, lang);
    sdk.setDefaultWidgetVersion(2);
    return sdk;
  }, [apiurl, apiurl]);

  useEffect(() => {
    if (!lang || intelliProveWidgets.locale === lang) return;
    intelliProveWidgets.changeLanguage(lang);
  }, [locale]);

  return <IntelliProveWidgetsContext.Provider value={intelliProveWidgets}>{children}</IntelliProveWidgetsContext.Provider>;
}

// Custom hook for accessing the IntelliProveAPI instance.
export const useIntelliProveWidgets = (): IntelliProveWidgets => {
  const context = useContext(IntelliProveWidgetsContext);
  if (!context) {
    throw new Error('useIntelliProveWidgets must be used within an IntelliProveWidgetsProvider');
  }
  return context;
};
